export default function(nga, admin) {
    let entity = admin.getEntity('purchase')
        //.updateMethod('patch')
        .label('purchases');

    let pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    entity.listView()
        .fields([
            nga.field('order').label('ORDER').isDetailLink(true),
            nga.field('user').label('USER').map(function (value, entry) {
                        return entry['user.name'] + ' ' + (entry['user.surname'] || '');
            }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'),
            nga.field('product').label('PRODUCT').isDetailLink(true).map(function (value, entry) {
                return entry['product.name'];
            }),
            nga.field('method').label('METHOD'),
            nga.field('status').label('STATUS').map(function (value, entry) {
                if (value)
                    return "active";
                else
                    return "inactive";
            }),
            nga.field('updated','date').label('UPDATED').format('yyyy-MM-dd'),
            nga.field('interested')
                .label('INVOICE')
                .template(function(entry){
                    if(entry.values.status == 'inactive'){
                        return null;
                    }

                    return '<ma-filtered-list-button label="{{ \'SHOW INVOICES\' | translate }}" entity-name="invoice" ' +
                        'filter="{  purchase: entry.values.id }" size="xs"></ma-filtered-list-button>'
                }),
        ])
        .url('purchases')
        .listActions(['edit', 'delete'])
        .filters([
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search order" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'),
            nga.field('status', 'choice')
                .choices([
                    { label: 'active', value: '1' },
                    { label: 'inactive', value: '0' }
                ]),
        ]);

    entity.editionView().fields([
        nga.field('id'),
        nga.field('user', 'reference')
            .map(function(value, entry) {
                return entry['user.id'];
            })
            .targetEntity(nga.entity('user').url('users'))
            .targetField(nga.field('name'))
            .perPage(0),
        nga.field('product', 'reference')
            .map(function(value, entry) {
                return entry['product.id'];
            })
            .targetEntity(nga.entity('product').url('products'))
            .targetField(nga.field('name'))
            .perPage(0),
        nga.field('status', 'boolean')
            .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'),
        nga.field('status_code'),
        nga.field('method', 'choice')
            .choices([
                {label: 'PAYPAL', value: 'paypal'},
                {label: 'CREDIT_CARD', value: 'credit_card'},
                {label: 'WIRE_TRANSFER', value: 'wire'}
            ]),
    ]);

    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/purchase/config.js
 **/